@use "../../../../../../src/styles/Constants.scss" as Constants;

.descriptionContainer {
	margin-bottom: Constants.$val-spacing-xl;
}
